package com.heelion.farmafreelance.push

import androidx.compose.runtime.Composable

/** Qui non si possono programmare notifiche ad app/browser chiusi: i promemoria restano solo su Android. */
@Composable
actual fun rememberPromemoriaLocali(): PromemoriaLocali? = null
